/**
 * Co-Producer / Touring Partner / Project Partner form
 */

import $ from 'jquery';
import _ from 'lodash';
import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import vueSelect from 'vue-select';
import refreshToken from '../mixins/refresh-token';

const dictionary = { en: { messages: { required: 'This field is mandatory' } } };

VeeValidate.Validator.localize(dictionary);

Vue.use(VeeValidate);

Validator.extend('pdf', {
    getMessage: field => 'The ' + field + ' must be a pdf file.',
    validate: value => value[0] ? /^(.+)\.(p|P)(d|D)(f|F)$/.test(value[0].name) : true
});

Validator.extend('no_160_space', {
    getMessage: field => 'The ' + field + ' field must be a valid email address.',
    validate: function (value) {
        if (value.includes(' ')) {
            return false;
        }

        return true;
    }
});

Validator.extend('url', {
    getMessage: field => 'The ' + field + '\'s address must be in the form http://www.website.com.',
    validate: (value) => value ? /^(ftp|http|https):\/\/[^ "]+$/.test(value) : true
});

const formItemComponentConfig = {
    /**
     * Component name
     * @type {String}
     */
    name: 'form-item',

    props: [
        'countries',
        'collaboratingsData',
        'internationalAccessData',
        'token',
        'previous',
        'action',
        'id',
        'categorie',
        'next',
        'readOnly',
        'errorBags',
        'partnerTypes'
    ],

    components: { 'vueSelect': vueSelect },

    mixins: [ refreshToken ],

    /**
     * Component data
     * @return {Object}
     */
    data () {
        const dataObject = {
            collaboratings: [{}],
            max_collaborating_index: 10,
            collaboratingError: false,
            internationalAccess: {},
            tokenVal: null
        };

        return dataObject;
    },

    methods: {
        addFormItem () {
            if (!this.readOnly) {
                this.collaboratings.push({
                    country: 75,
                    contact_form_of_address: 'Mr',
                    involvement_in_project: ''
                });
                if (this.collaboratings.length >= 1) {
                    this.collaboratingsError = false;
                }
            }
        },
        deleteFormItem (index) {
            if (!this.readOnly) {
                this.collaboratings.splice(index, 1);
                if (this.collaboratings.length < 1) {
                    this.collaboratingsError = true;
                }
            }
        },
        validateForm (e) {
            let self = this;

            e.preventDefault();
            if (this.collaboratings.length > 0) {
                e.preventDefault();

                this.$validator.validateAll().then((valid) => {
                    if (valid) {
                        let canSubmit = true;

                        $('[data-behavior~=phone-number]').each(function () {
                            let frontField = $(this).find('input[type=text]');
                            // let hiddenField = $(this).find('input[type=hidden]');
                            let fullField = $(this).next();

                            if ($(frontField).attr('number') === 'phone') {
                                if (frontField.intlTelInput('isValidNumber')) {
                                    let phoneNumber = frontField.intlTelInput('getNumber');

                                    fullField.val(phoneNumber);
                                } else {
                                    canSubmit = false;
                                    const field = self.$validator.fields.find({
                                        name: $(frontField).attr('name'),
                                        scope: self.$options.scope
                                    });

                                    self.$validator.errors.add({
                                        id: field.name,
                                        field: field.name,
                                        msg: 'Invalid phone number',
                                        scope: self.$options.scope
                                    });

                                    field.setFlags({
                                        invalid: true,
                                        valid: false,
                                        validated: true
                                    });

                                    $([document.documentElement, document.body]).animate({
                                        scrollTop: $(frontField).parents()
                                            .eq(2)
                                            .offset().top - 130
                                    }, 500);
                                }
                            }
                            if ($(frontField).attr('number') === 'mobile') {
                                if ($(frontField).val()) {
                                    if (frontField.intlTelInput('isValidNumber')) {
                                        let phoneNumber = frontField.intlTelInput('getNumber');

                                        fullField.val(phoneNumber);
                                    } else {
                                        canSubmit = false;
                                        const field = self.$validator.fields.find({
                                            name: $(frontField).attr('name'),
                                            scope: self.$options.scope
                                        });

                                        self.$validator.errors.add({
                                            id: field.name,
                                            field: field.name,
                                            msg: 'Invalid phone number',
                                            scope: self.$options.scope
                                        });

                                        field.setFlags({
                                            invalid: true,
                                            valid: false,
                                            validated: true
                                        });

                                        $([document.documentElement, document.body]).animate({
                                            scrollTop: $(frontField).parents()
                                                .eq(2)
                                                .offset().top - 130
                                        }, 500);
                                    }
                                }
                            }
                        });

                        if (canSubmit && this.validateInternational(null, true) && this.validateCheckbox(null, true)) {
                            let btnSpinner = $('.btn--spinner', e.target);

                            btnSpinner.addClass('right-spin');
                            e.target.submit();

                            return true;
                        }
                        // Valid alls inputs
                        if (this.categorie === 'nextstage') {
                            let btnSpinner = $('.btn--spinner', e.target);

                            btnSpinner.addClass('right-spin');
                            e.target.submit();

                            return true;
                        }
                    } else {
                        let fieldName = this.errors.items[0].field;

                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('[name="' + fieldName + '"]').parent()
                                .offset().top - 130
                        }, 500);
                    }
                })
                    .catch(() => {
                        return false;
                    });
            } else if (this.categorie === 'digital') {
                e.target.submit();
            } else if (this.categorie === 'nextstage') {
                e.target.submit();
            } else {
                return false;
            }
        },
        readUrl (e) {
            if ($(e.target)[0].files && $(e.target)[0].files[0]) {
                let reader = new FileReader();

                reader.onload = function (event) {
                    $('#' + $(e.target).data('img-id')).attr('src', event.target.result);
                };

                reader.readAsDataURL($(e.target)[0].files[0]);
            }
        },
        validatePhone (e) {
            const field = this.$validator.fields.find({
                name: $(e.target).attr('name'),
                scope: this.$options.scope
            });

            if (!field) return;

            if (!$(e.target).intlTelInput('isValidNumber') && $(e.target).val()) {
                this.$validator.errors.add({
                    id: field.name,
                    field: field.name,
                    msg: 'Invalid phone number',
                    scope: this.$options.scope
                });

                field.setFlags({
                    invalid: true,
                    valid: false,
                    validated: true
                });
            } else {
                this.$validator.errors.removeById(field.name);
            }

            return true;
        },
        theresEnough () {
            if (this.collaboratings.length < this.max_collaborating_index) {
                return true;
            } else {
                return false;
            }
        },
        validateInternational (event, submit = false) {
            if (this.categorie !== 'opera' && this.categorie !== 'dance') {
                return true;
            }

            let field = this.$validator.fields.find({
                name: 'internationnal_access',
                scope: this.$options.scope
            });

            let canSubmit = true;

            if (!field) return;

            if (
                (this.internationalAccess.partner_internationnal_access_touring === undefined || !this.internationalAccess.partner_internationnal_access_touring) &&
                (this.internationalAccess.partner_internationnal_access_streaming === undefined || !this.internationalAccess.partner_internationnal_access_streaming) &&
                (this.internationalAccess.partner_internationnal_access_other === undefined || !this.internationalAccess.partner_internationnal_access_other)
            ) {
                canSubmit = false;

                if (!this.errors.has(field.name)) {
                    this.$validator.errors.add({
                        id: field.name,
                        field: field.name,
                        msg: 'Please choose at least one option',
                        scope: this.$options.scope
                    });

                    field.setFlags({
                        invalid: true,
                        valid: false,
                        validated: true
                    });
                }
            } else {
                this.errors.removeById(field.name);
            }

            if (submit && this.errors.items[0] !== undefined) {
                this.scrollToFirstError();
            }

            return canSubmit;
        },
        validateCheckbox (event, submit = false) {
            if (this.categorie === 'education' || this.categorie === 'digital') {
                return true;
            }

            let canSubmit = true;
            // let self = this;

            for (let i = 0; i < this.collaboratings.length; i++) {
                let field = this.$validator.fields.find({
                    name: 'collaborating[' + i + '][partner_type]',
                    scope: this.$options.scope
                });

                if (!field) return;
                if (
                    (this.collaboratings[i].coproducing_partner === undefined || !this.collaboratings[i].coproducing_partner) &&
                    (this.collaboratings[i].touring_partner === undefined || !this.collaboratings[i].touring_partner) &&
                    (this.collaboratings[i].streaming_partner === undefined || !this.collaboratings[i].streaming_partner) &&
                    (this.collaboratings[i].project_partner === undefined || !this.collaboratings[i].project_partner)
                ) {
                    canSubmit = false;

                    if (!this.errors.has(field.name)) {
                        this.$validator.errors.add({
                            id: field.name,
                            field: field.name,
                            msg: 'At least one partner type needs to be checked',
                            scope: this.$options.scope
                        });

                        field.setFlags({
                            invalid: true,
                            valid: false,
                            validated: true
                        });
                    }
                } else {
                    this.errors.removeById(field.name);
                }
                if (submit && this.errors.items[0] !== undefined) {
                    this.scrollToFirstError();
                }
            }

            return canSubmit;
        },

        scrollToFirstError () {
            let fieldName = this.errors.items[0].field;

            $([document.documentElement, document.body]).animate({
                scrollTop: $('[name="' + fieldName + '"]').parent()
                    .offset().top - 130
            }, 500);
        }
    },

    created () {
        this.collaboratings = this.collaboratingsData;
        this.internationalAccess = this.internationalAccessData;
        this.tokenVal = this.token;
    },

    mounted () {
        _.each(this.errorBags, (value, fieldname) => {
            const field = this.$validator.fields.find({ name: fieldname });

            this.$validator.errors.add({
                id: field.name,
                field: field.name,
                msg: value[0],
                scope: this.$options.scope
            });

            field.setFlags({
                invalid: true,
                valid: false,
                validated: true
            });
        });

        if (this.errors.items[0] !== undefined) {
            let fieldName = this.errors.items[0].field;

            $([document.documentElement, document.body]).animate({
                scrollTop: $('[name="' + fieldName + '"]').parent()
                    .offset().top - 130
            }, 500);
        }
    },

    updated () {
        if ($('[data-behavior~=phone-number]').length > 0) {
            $.fn.intlTelInput.loadUtils('https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/13.0.2/js/utils.js');
            $('[data-behavior~=phone-number]').each(function () {
                if ($(this).attr('state') !== 'rendered') {
                    let $frontField = $(this).find('input[type=text]');
                    let $hiddenField = $(this).find('input[type=hidden]');
                    let initialCountry = 'FR';

                    $frontField.intlTelInput({
                        initialCountry: initialCountry,
                        hiddenInput: $hiddenField.attr('name'),
                        customPlaceholder: function (selectedCountryPlaceholder) {
                            return 'Example: ' + selectedCountryPlaceholder;
                        }
                    });

                    $frontField.intlTelInput('setNumber', $hiddenField.val());
                    if ($frontField.val().length !== 0) {
                        let countryData = $frontField.intlTelInput('getSelectedCountryData');

                        $frontField.intlTelInput('setCountry', countryData.iso2);
                    }
                    $(this).attr('state', 'rendered');
                }
            });
        }

        for (let i = 0; i < this.collaboratings.length; i++) {
            let fieldName = 'collaborating[' + i + '][country]';
            let relatedData = this.collaboratings[i].selected_country;

            if (relatedData) {
                const field = this.$validator.fields.find({
                    name: fieldName,
                    scope: this.$options.scope
                });

                if (field) {
                    this.$validator.errors.removeById(field.id);
                }
            }
        }
    }
};

const formItemComponent = Vue.extend(formItemComponentConfig);

export default formItemComponent;
